import { IProjectUiComponent, ISingleParagraph, ISplitParagraph } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import Img from '../../../../components/Img';
import Paragraph from '../../../Blog/Article/Paragraph';
import styles from './DevelopmentComponentsBlock.module.scss';

type DevelopmentComponentProps = {
  item: ISplitParagraph | ISingleParagraph
};
const DevelopmentComponent = ({ item }: DevelopmentComponentProps) => (
  <div className={classnames(styles.component, {
    [styles.component_double]: item.type === 'split-paragraph',
    [styles.component_single]: item.type === 'single-paragraph',
  })}
  >
    {item.type === 'split-paragraph' ? (
      <>
        {item.paragraphs.map((splitParagraph) => (
          <div
            key={splitParagraph.id}
            className={styles.component_double__column}
          >
            <div className={styles.columnContent}>
              <p className={classnames(styles.component__title, 'title6')}>{splitParagraph.data.title}</p>
              <Paragraph
                className={styles.component__text}
                value={splitParagraph.data.text}
              />
            </div>
            <div className={styles.component__image}>
              <Img
                width={splitParagraph.data.image.width || 327}
                height={splitParagraph.data.image.height || 193}
                src={splitParagraph.data.image.url}
                alt={splitParagraph.data.image.alternativeText || 'development image'}
                withPreloader
              />
            </div>
          </div>
        ))}
      </>
    ) : (
      <>
        <div className={styles.component__content}>
          <p className={classnames(styles.component__title, 'title6')}>{item.data.title}</p>
          <Paragraph
            className={styles.component__text}
            value={item.data.text}
          />
        </div>
        <div className={styles.component__image}>
          <Img
            width={item.data.image.width || 327}
            height={item.data.image.height || 193}
            src={item.data.image.url}
            alt={item.data.image.alternativeText || 'development image'}
            withPreloader
          />
        </div>
      </>
    )}

  </div>
);

type DevelopmentComponentsBlockProps = {
  data: IProjectUiComponent
};
const DevelopmentComponentsBlock = ({ data }: DevelopmentComponentsBlockProps) => (
  <section className={classnames(styles.components, 'container')}>
    <h4 className={classnames('title4', styles.title)}>UI/UX Design</h4>
    <div className={styles.components__content}>
      {data.content.map(item => (
        <DevelopmentComponent
          key={`${item.id}/${item.type}`}
          item={item}
        />
      ))}
    </div>
  </section>
);

export default DevelopmentComponentsBlock;
